'use client';
import { useCategoryTree } from './useCategoryTree';
import { useTelegramGeoGetTreeMultilanguage } from '@/generated';
import { useMemo } from 'react';
import { buildCategoryNameDict, convertGeoTreeToFlatDicts, convertTreeToFlatDict } from '@/utils/SEOPathModule/utils';
export const useGetCompleteDict = () => {
  const categories = useCategoryTree();
  const geo = useTelegramGeoGetTreeMultilanguage();
  const data = useMemo(() => {
    if (!categories.data || !geo.data) return undefined;
    const categoryIdDict = convertTreeToFlatDict(categories.data);
    return {
      categoryIdDict,
      categoryNameDict: buildCategoryNameDict(categoryIdDict),
      geoDict: convertGeoTreeToFlatDicts(geo.data),
    };
  }, [categories.data, geo.data]);
  return {
    data,
    isLoading: categories.isLoading || geo.isLoading,
    isError: categories.isError || geo.isError,
    error: categories.error ?? geo.error,
  };
};
